import { CheckCircleFilled, CloseCircleFilled, QuestionCircleFilled } from '@ant-design/icons';


const BoolDisplay = (props) => {

  if (props.val == true){
    return <CheckCircleFilled style={{ color: 'green', fontSize: '15px' }} />
  } else if (props.val == false) {
    return <CloseCircleFilled style={{ color: 'red', fontSize: '15px' }} />
  } else {
    return <QuestionCircleFilled style={{ color: 'gray', fontSize: '15px' }} />;
  }
};

export default BoolDisplay;
